import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ISuperTableCalculation, ISuperTableCalculationFunction } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { cloneDeep } from 'lodash-es';
import { FIRST_ELEMENT_INDEX, SECOND_ELEMENT_INDEX } from '../../../../../../../aumico-lib-core-fe/src/lib';
import { ISuperTableAddCalculationResult } from '../../../../interfaces/super-table-add-calculation-result.interface';
import { ISuperTableItemSelection } from '../../../../interfaces/super-table-item-selection.interface';

@UntilDestroy()
@Component({
    selector: 'super-table-subtraction-row',
    templateUrl: './super-table-subtraction-row.component.html',
    styleUrls: ['./super-table-subtraction-row.component.scss'],
})
export class SuperTableSubtractionRowComponent implements OnInit, OnChanges {
    @Input() selectionOptions: ISuperTableItemSelection[] = [];
    @Input() existingCalculation: ISuperTableCalculation | undefined;
    selectedItems: ISuperTableItemSelection[] = [];
    titleControl = new FormControl('');
    xDropdownOpen = false;
    yDropdownOpen = false;
    xItem: ISuperTableItemSelection | undefined;
    yItem: ISuperTableItemSelection | undefined;

    @Output() calculationOutput: EventEmitter<ISuperTableAddCalculationResult> =
        new EventEmitter<ISuperTableAddCalculationResult>();

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['existingCalculation']?.currentValue) {
            this.titleControl.setValue(this.existingCalculation.title);

            const selectedRows = this.existingCalculation.rowsIds;
            const matchingXRowSelection = this.selectionOptions.find(
                (option) => selectedRows[FIRST_ELEMENT_INDEX] === option.name,
            );

            this.xItem = cloneDeep<ISuperTableItemSelection>(matchingXRowSelection);

            const matchingYRowSelection = this.selectionOptions.find(
                (option) => selectedRows[SECOND_ELEMENT_INDEX] === option.name,
            );

            this.yItem = cloneDeep<ISuperTableItemSelection>(matchingYRowSelection);

            this.selectedItems = [matchingXRowSelection, matchingYRowSelection];

            this.calculationOutput.emit({
                title: this.titleControl.value,
                function: ISuperTableCalculationFunction.SUBTRACTION,
                rowSelections: this.selectedItems,
            });
        }
    }

    ngOnInit(): void {
        this.titleControl.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
            if (this.xItem != null && this.yItem != null) {
                this.calculationOutput.emit({
                    title: value,
                    function: ISuperTableCalculationFunction.SUBTRACTION,
                    rowSelections: this.selectedItems,
                });
            }
        });
    }

    toggleXDropdown(): void {
        this.xDropdownOpen = !this.xDropdownOpen;
    }

    toggleYDropdown(): void {
        this.yDropdownOpen = !this.yDropdownOpen;
    }

    onSelectXItem(item: ISuperTableItemSelection): void {
        if (this.xItem?.name === item.name) {
            //deselect yItem
            this.xItem = null;
        } else {
            this.xItem = item;
        }

        this.selectedItems = [this.xItem, this.yItem];

        this.calculationOutput.emit({
            title: this.titleControl.value,
            function: ISuperTableCalculationFunction.SUBTRACTION,
            rowSelections: this.selectedItems,
        });
    }

    onSelectYItem(item: ISuperTableItemSelection): void {
        if (this.yItem?.name === item.name) {
            //deselect yItem
            this.yItem = null;
        } else {
            this.yItem = item;
        }

        this.selectedItems = [this.xItem, this.yItem];

        this.calculationOutput.emit({
            title: this.titleControl.value,
            function: ISuperTableCalculationFunction.SUBTRACTION,
            rowSelections: this.selectedItems,
        });
    }

    removeXItem() {
        this.xItem = null;

        this.selectedItems = this.selectedItems.splice(0, 1);

        this.calculationOutput.emit({
            title: this.titleControl.value,
            function: ISuperTableCalculationFunction.SUBTRACTION,
            rowSelections: this.selectedItems,
        });
    }

    removeYItem() {
        this.yItem = null;

        this.selectedItems = this.selectedItems.splice(1, 1);

        this.calculationOutput.emit({
            title: this.titleControl.value,
            function: ISuperTableCalculationFunction.SUBTRACTION,
            rowSelections: this.selectedItems,
        });
    }
}
